import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 px-4 bg-dark-100" data-id="element-124">
      <div className="max-w-[680px] mx-auto" data-id="element-125">
        <div className="bg-dark-100 border border-gold/20 rounded-lg p-6 md:p-8 text-center flex flex-col items-center" data-id="element-126">
          <ShieldCheckIcon className="w-10 h-10 text-gold mb-4" data-id="element-127" />

          <h2 className="text-2xl font-bold text-body mb-6" data-id="element-128">
            LA GARANTÍA DE LOS 7 DÍAS
          </h2>

          <div className="space-y-2 text-sm text-sub max-w-[520px] mx-auto leading-relaxed" data-id="element-129">
            <p data-id="element-130">Empieza el protocolo.</p>
            <p data-id="element-131">Completa los primeros 7 días exactamente como indica la guía.</p>
            <p className="text-body font-medium" data-id="element-132">
              Si después de esos 7 días no sientes una diferencia real en tu
              nivel de calma, claridad y enfoque —
            </p>
            <p data-id="element-133">te devolvemos cada centavo. Sin preguntas. Sin drama.</p>

            <p className="font-bold text-gold mt-6 pt-6 border-t border-divider" data-id="element-134">
              ¿Por qué 7 días y no 30?
            </p>
            <p data-id="element-135">Porque si el protocolo va a funcionar para ti,</p>
            <p data-id="element-136">lo vas a sentir en la primera semana.</p>
            <p className="italic" data-id="element-137">
              Eso es lo seguros que estamos de este sistema.
            </p>
          </div>
        </div>
      </div>
    </section>;
}